var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4372 2.58911C22.6062 2.76892 22.6479 3.03388 22.5422 3.2569L13.5422 22.2569C13.4357 22.4818 13.2013 22.6176 12.9531 22.5982C12.705 22.5788 12.4946 22.4081 12.4244 22.1693L10.6597 16.1693C10.6034 15.9779 10.6459 15.7711 10.7732 15.6174L18.7221 6.01784L8.34324 13.2569C8.19391 13.361 8.00537 13.3917 7.8307 13.3404L1.8307 11.5757C1.58537 11.5035 1.41274 11.2838 1.40067 11.0284C1.3886 10.7729 1.53974 10.5379 1.77716 10.443L21.7772 2.44296C22.0063 2.35131 22.2682 2.4093 22.4372 2.58911ZM17.3686 5.49883L3.83201 10.9135L7.89299 12.1079L17.3686 5.49883ZM19.4074 7.07181L11.901 16.1369L13.1315 20.3208L19.4074 7.07181Z"
  })));
};
export default SvgSend;